module.exports = "/images/mastercard.svg?956ace873baf026438177929c932a82d";